import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { MaskService } from 'src/app/shared/services/mask.service';
import { ExecucaoOrcamentaria } from '../../models/execucao-orcamentaria.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ExecucaoOrcamentariaService } from '../../services/execucao-orcamentaria.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-detalhe-projeto-execucao-orcamentaria-execucao-edit',
  templateUrl: './detalhe-projeto-execucao-orcamentaria-execucao-edit.component.html',
  styleUrls: ['./detalhe-projeto-execucao-orcamentaria-execucao-edit.component.scss']
})
export class DetalheProjetoExecucaoOrcamentariaExecucaoEditComponent extends BaseFormComponent<ExecucaoOrcamentaria> implements OnInit {

  @Input() idExecucao: number;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  list: any;
  execucaoList: any;
  months: any;
  permissionExec: any;
  permission: any;
  warnings: any[];
  filter: any;
  selected_filter: {} = {subprojetos: null, recursos: null};
  status: any;

  constructor(
    private myService: ExecucaoOrcamentariaService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initList();
    });
  }

  initList(obj = null) {
    this.loading();
    this.addSub(
      this.myService.getExcucaoList(obj, this.idExecucao).subscribe({
        next: (res) => {
          this.execucaoList = res['list'];
          console.log(res['list'])
          this.months = res['months'];
          this.initForm();
          this.permissionExec = res['permission'];
          this.warnings = res['warnings'];
          this.filter = res['filter'];
          this.status = res['status'];
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    )
  }

  getDataCreate()  {
    let data = {};
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.idExecucao) {
        this.addSub(
          this.myService.previsaoUpdate(this.getDataCreate(), this.idExecucao).subscribe({
            next: (res) => {
              this.loaded();
              this.confirmation("Dotação alterada com sucesso!").subscribe(() => {
                window.location.reload();
              })
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }


  view(id: number) {
    this.router.navigate(['projetos', 'projeto', this.idProjeto, 'execucao-orcamentaria', id]);
  }


  filterList(event: any, filtro: string) {
    // atribui objeto dinamicamente com a chave baseada no valor de 'filtro'
    if(event?.length) {
      this.selected_filter[filtro] = event;
    } else {
      this.selected_filter[filtro] = null;
    }

    // Passa o objeto dinâmico para a função initList
    this.initList(this.selected_filter);
  }
  monthExecution(month, data){
    return data?.find(d => d.mes == month) ?? {};
  }

  getFormArray(field: string): FormArray {
    return this.form.get(field) as FormArray;
  }
  
  formatarMedidaFisica(index: number, field: string, form: string) {
    let valueField = this.getFormArray(form).controls[index].get(field)?.value;
    let value = this.maskService.formatarMedidaFisica(valueField, 2);
    this.getFormArray(form).controls[index].get(field).setValue(value);
  }

  initForm():void {
    const project = this.execucaoList.find(e=> e.id == 'project');
    this.form = new FormGroup({
      previsao: new FormArray(this.months.map((mes, index) => {
        const previsao = project?.previsao?.find(p => p.mes_competencia == index+1) //mudar em vez de pegar a previsão, pegar 1 para cada dia do mes, e ai sim pegar a previsao
        return new FormGroup({
          id: new FormControl(previsao?.id ?? null),
          mes_competencia: new FormControl(index + 1),
          valor_previsao_desembolso: new FormControl(this.maskService.formatarMedidaFisica(previsao?.valor_previsao_desembolso, 2)),
        });
      }))
    })
    console.log(this.form)
  }
}
